export const ALLOWED_UPLOAD_EXTENSIONS = ["html", "pptx", "pdf"];
export const CONVERSION_STATUS_POLL_INTERVAL_MS = 5000;
